import { useTranslation } from "react-i18next";
import { localeNames, supportedLocales } from "@waveops/locales";

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation("common");
  const current = (i18n.resolvedLanguage ?? "en") as "en" | "es";
  return (
    <label className="flex items-center gap-2 text-xs text-slate-500">
      <span>{t("languageSwitcher.label")}</span>
      <select
        value={current}
        onChange={(e) => void i18n.changeLanguage(e.target.value)}
        className="rounded-md border border-slate-300 bg-white px-2 py-1 text-xs"
        aria-label={t("languageSwitcher.label")}
      >
        {supportedLocales.map((code) => (
          <option key={code} value={code}>
            {localeNames[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
